module.exports = __webpack_public_path__ + "media/images/pages/bg_dataStation-2dd194a4d8897d502810e0babd7398ab.jpg";